<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">All Transactions</div>
        <span class="body-1 greyDarken1--text"
          >List of all payment transactions</span
        >
      </div>
    </v-card-title>
    <v-card-text class="px-0">
      <v-data-table
        :headers="headers"
        :items="transactions"
        :pagination.sync="pagination"
        :total-items="total"
        :rowsPerPageItems="rowsPerPageItems"
        item-key="id"
        :loading="loading"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              {{ $t("payment_transaction.charged_for." + props.item.txn_type) }}
            </td>
             <td>
              {{ DEFINES.PREMIUM_SCREENING_PRICING_TYPE_STR[props.item.pricing_type ? props.item.pricing_type : DEFINES.PREMIUM_SCREENING_PRICING_TYPE.NORMAL ]}}
            </td>
            <td>
              <v-tooltip v-if="props.item.screener_title" top color="greyDarken1">
                <template v-slot:activator="{on}">
                  <span v-on="on">{{ props.item.screener_title | truncate }}</span>
                </template>
                <span class="white--text body-1">{{ props.item.screener_title }}</span>
              </v-tooltip>
              <span v-else>---</span>
            </td>
            <td>{{ props.item.quantity }}</td>
            <td>{{ props.item.currency }}</td>
            <td>
              {{ getCurrencySymbol(props.item.currency)
              }}{{ props.item.total_amount }}
            </td>
            <td>{{ props.item.txn_status | capitalize }}</td>
            <td>
              <v-icon v-if="props.item.is_paid" color="success"
                >mdi-check</v-icon
              >
              <v-icon v-else color="error">mdi-window-close</v-icon>
            </td>
            <td>
              <v-tooltip slot="append" top color="white">
                <v-chip
                  slot="activator"
                  outline
                  color="secondary"
                  class="white--text cursor-pointer"
                  small
                  @click.stop="viewReceipt(props.item.receipt_url)"
                >
                  <strong>Download</strong>
                  <v-icon>mdi-download</v-icon>
                </v-chip>
                <span class="greyDarken3--text body-1">
                  Click to download the receipt
                </span>
              </v-tooltip>
            </td>
            <td>
              {{
                moment
                  .utc(props.item.created_at)
                  .local()
                  .format("Do MMM YYYY, h:mm a")
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { getCurrencySymbol } from "@/helper";

export default {
  name: "TransactionList",
  data() {
    return {
      transactions: [],
      headers: [
        {
          text: "Charged For",
          align: "left",
          sortable: false,
          value: "txn_type",
        },
        {
          text: "Pricing Type",
          align: "left",
          sortable: false,
          value: "pricing_type",
        },
        {
          text:"Event",
          align: "left",
          sortable: false,
          value: "screener_title",
        },
        { text: "Quantity", align: "left", sortable: true, value: "quantity" },
        { text: "Currency", align: "left", sortable: false, value: "currency" },
        {
          text: "Total Amount",
          align: "left",
          sortable: true,
          value: "total_amount",
        },
        { text: "Status", align: "left", sortable: false, value: "txn_status" },
        { text: "Paid", align: "left", sortable: false, value: "is_paid" },
        {
          text: "Receipt",
          align: "left",
          sortable: false,
          value: "receipt_url",
        },
        {
          text: "Created At",
          align: "left",
          sortable: true,
          value: "created_at",
        },
      ],
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      search: "",
      loading: false,
      total: null,
    };
  },
  created() {
    this.listTransactionsFromApi();
  },
  watch: {
    pagination: {
      handler: "listTransactionsFromApi",
      deep: true,
    },
  },
  methods: {
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
    viewReceipt(receipt_url) {
      if (receipt_url) {
        window.open(receipt_url);
      }
    },
    getCurrencySymbol(currency) {
      return getCurrencySymbol(currency);
    },
    async listTransactionsFromApi() {
      try {
        this.loading = true;
        // Pagination
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        var offset = this.getPaginationOffset(rowsPerPage, page);
        // Payload
        let payload = {
          offset: offset,
          limit: rowsPerPage,
          sort: sortBy,
          sorting_order: descending,
          search: this.search,
          filters: {},
        };
        var response = await this.$store.dispatch(
          "company/listTransaction",
          payload
        );
        this.transactions = response.transactions.data;
        this.total = response.transactions.total;

        this.loading = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
  },
};
</script>

<style>
</style>
